import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';
import { InvoiceTask } from '@/hooks/api/models';

/**
 * 2530. 請求タスクBoard請求金額取込
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id/board_amount
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
};

const updateBillingAmountByBoard = (props: Props): Promise<InvoiceTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.task_id}/update_billing_amount_by_board`,
    { params: props }
  );
};

export const useUpdateBillingAmountByBoard = () => {
  return useMutation({
    mutationFn: updateBillingAmountByBoard,
  });
};
